import { render } from "./ProductDetailR.vue?vue&type=template&id=2c67b8a6&scoped=true"
import script from "./ProductDetailR.vue?vue&type=script&lang=js"
export * from "./ProductDetailR.vue?vue&type=script&lang=js"

import "./ProductDetailR.vue?vue&type=style&index=0&id=2c67b8a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c67b8a6"]])

export default __exports__